export { default } from "truth-helpers/helpers/and";